import xss from 'xss'

const xssFilter = new xss.FilterXSS({
  whiteList: {
    ...xss.whiteList,
    a: [...xss.whiteList.a, 'rel'],
  },
})

/**
 * Sanitizes HTML before it is passed to dangerouslySetInnerHTML.
 * Used to prevent DOM-based XSS from markdown/CMS-authored content.
 */
export function sanitizeHtml(html) {
  if (!html) return html
  return xssFilter.process(html)
}

// Narrowly-scoped policy for CookieBanner's server-supplied CSS only.
// Do not reuse this for other content (API descriptions, notification
// messages, etc.) since allowing <style> lets injected content deliver
// arbitrary CSS-based UI spoofing/overlay attacks.
const cookieBannerXssFilter = new xss.FilterXSS({
  whiteList: {
    ...xss.whiteList,
    a: [...xss.whiteList.a, 'rel'],
    style: [],
  },
})

export function sanitizeCookieBannerHtml(html) {
  if (!html) return html
  return cookieBannerXssFilter.process(html)
}
